(function () {
  "use strict";

  // This is only a layout fix for Empire's native, AI-grid-decorated flydown.
  // The BG alias search and the AI ranking scripts keep ownership of results.
  if (!window.Shopify || window.Shopify.shop !== "5135b9-3.myshopify.com") return;

  var style = document.createElement("style");
  style.id = "storeoperator-search-flydown-fix";
  style.textContent =
    ".so-ai-search:not(.live-search--takeover) .search-flydown{" +
    "width:var(--so-flydown-width,min(760px,calc(100vw - 24px)))!important;" +
    "left:var(--so-flydown-left,0px)!important;transform:none!important}" +
    ".so-ai-search:not(.live-search--takeover) .search-flydown[data-animation-state=open]{" +
    "height:auto!important;max-height:var(--so-flydown-max-height,70vh)!important;" +
    "overflow-y:auto!important;overflow-x:hidden!important;overscroll-behavior:contain}" +
    ".so-ai-search.live-search--takeover .search-flydown[data-animation-state=open]{" +
    "max-height:calc(100dvh - 64px)!important;overflow-y:auto!important;" +
    "overflow-x:hidden!important;overscroll-behavior:contain}";
  (document.head || document.documentElement).appendChild(style);

  function position() {
    var roots = document.querySelectorAll(".so-ai-search[data-live-search]");
    Array.prototype.forEach.call(roots, function (root) {
      if (root.classList.contains("live-search--takeover")) return;
      var form = root.querySelector("[data-live-search-form]");
      var flydown = root.querySelector("[data-live-search-flydown]");
      if (!form || !flydown || !root.getClientRects().length) return;

      var anchor = form.getBoundingClientRect();
      var input = root.querySelector("[data-live-search-input]");
      var inputBottom = input ? input.getBoundingClientRect().bottom : anchor.top;
      var width = Math.min(760, Math.max(0, window.innerWidth - 24));
      var x = Math.max(12, Math.min(anchor.left, window.innerWidth - width - 12));
      flydown.style.setProperty("--so-flydown-width", width + "px");
      flydown.style.setProperty("--so-flydown-left", (x - anchor.left) + "px");
      flydown.style.setProperty(
        "--so-flydown-max-height",
        Math.max(0, Math.min(560, window.innerHeight - inputBottom - 12)) + "px"
      );
    });
  }

  document.addEventListener("focusin", position, true);
  document.addEventListener("input", position, true);
  window.addEventListener("resize", position);
  window.addEventListener("scroll", position, true);
  document.addEventListener("shopify:section:load", position);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", position);
  else position();
}());